/*
 * @Author: ZhaoDong
 * @Date: 2022-10-27 09:40:26
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-10-31 11:01:54
 * @Description: 优惠券管理
 */
import request from '@/utils/request'

// 优惠券列表
export function couponList(data) {
  return request({
    url: '/coupon/coupon-set/items',
    method: 'post',
    data
  })
}

// 优惠券新增
export function couponCreate(data) {
  return request({
    url: '/coupon/coupon-set/create',
    method: 'post',
    data
  })
}

// 优惠券编辑
export function couponUpdate(data) {
  return request({
    url: '/coupon/coupon-set/update',
    method: 'post',
    data
  })
}

// 优惠券详情
export function couponDetail(data) {
  return request({
    url: '/coupon/coupon-set/detail',
    method: 'post',
    data
  })
}

// 优惠券更新状态
export function couponUpdateState(data) {
  return request({
    url: '/coupon/coupon-set/update-state',
    method: 'post',
    data
  })
}

// 优惠券删除
export function couponDelete(data) {
  return request({
    url: '/coupon/coupon-set/delete',
    method: 'post',
    data
  })
}

// 优惠券记录
export function couponRecordList(data, params) {
  return request({
    url: '/coupon/coupon-record/items',
    method: 'post',
    params,
    data
  })
}

// 优惠券记录-操作
export function couponOpera(data) {
  return request({
    url: '/coupon/coupon-record/opera',
    method: 'post',
    data
  })
}
